import React, { useRef } from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_EL_EJE_IMAGE_PATH from 'images/experience_el_eje.jpg'
import EXPERIENCE_EL_EJE_SONG_PATH from 'audio/1. UN ANALISIS  MB.mp3'

const ElEjeText = () => (
	<span className="text-left">
		<p>La aceptación.</p>

		<p>En ella concurren las alegrías y temores de tu ser.</p>

		<p>Sus contradicciones.</p>

		<p>La profundización en el océano de tus propias angustias fue culminado.</p>

		<p>¿Cuáles fueron las preguntas, los temores afrontados y las alegrías permitidas para alcanzarlo?</p>

		<p>No sos sin la dualidad.</p>

		<p>Danzar con tus partes para observar lo que se revela cuando la luz deja entrever la sombra.</p>

		<p>Abraza la danza.</p>

		<p>Encontrá tu equilibrio.</p>
	</span>
)

import useVantas from '../../use_vantas.js'

import HALO from 'vanta/src/vanta.halo.js'

const ExperienceElEje = ({ is_active, ...props }) => {
	const [ canvas_root_ref , , canvasFadeOut ] = useVantas({
		is_active,
		backgroundAlpha: 0,
		effect: HALO,
		effect_options: {
			backgroundAlpha: 0,
			mouseControls: false,
			touchControls: false,
			gyroControls: false,
			minHeight: 200.00,
			minWidth: 200.00,
			amplitudeFactor: 0,
			xOffset: 0.02,
			yOffset: 0.43,
			size: 0.5
		},
		canvasReady: canvas => {
			// TODO: Vantas HALO does not support backgroundAlpha
			// replace it with a different effect (one from shadertoys maybe)
			canvas.style.mixBlendMode = 'lighten'
		}
	});

	return (<Experience
		r_ref={canvas_root_ref}
		image={EXPERIENCE_EL_EJE_IMAGE_PATH}
		title={"El Eje"}
		phrase={"¿Qué descubrís cuando te animás a quedarte justo en el centro de tu contradicción, ahí donde tus luces proyectan la sombra que aún no nombraste?"}
		phrase_rect={{ top: 90, left: 50, width: 55, height: 20 }}
		text={<ElEjeText />}
		text_rect={{ top: 45, left: 52, width: 60, height: 50 }}
		text_interaction_zone_rect={{ top: 10.15, left: 25.8, width: 8, height: 9 }}
		song={EXPERIENCE_EL_EJE_SONG_PATH}
		song_rect={{ top: 7, left: 51.8, width: 10, height: 13 }}
		is_active={is_active}
		onBeforeBack={canvasFadeOut}
		{...props}
	/>)			
}

export default ExperienceElEje